import React from 'react';
import { joinClasses } from '../../../../../../Utils/className.util';

//@ts-ignore
import styles from './Input.module.scss';
import Text from '../../../Text';

export interface InputProps extends React.HTMLProps<HTMLInputElement> {
	label?: string;
	hasError?: boolean;
	className?: string;
	prefix?: string;
	suffix?: string | React.ReactNode;
}

const Input = React.forwardRef<
	HTMLInputElement,
	React.PropsWithChildren<InputProps>
>(
	(
		{ label, hasError = false, className, prefix = '', suffix, ...inputProps },
		ref,
	) => (
		<div
			className={joinClasses([
				'form-group',
				className,
				hasError ? styles.invalid : undefined,
			])}
		>
			<div className={joinClasses([styles.wrapper, 'input-group'])}>
				{prefix && (
					<div className={styles.prefix}>
						<Text tx={prefix} inline />
					</div>
				)}
				<input
					className={joinClasses([
						'form-control',
						styles.input,
						hasError ? styles.invalid : undefined,
						suffix && styles.withSuffix,
						prefix && styles.withPrefix,
					])}
					ref={ref}
					{...inputProps}
				/>
				{suffix && (
					<div className={styles.suffix}>
						{React.isValidElement(suffix) ? (
							suffix
						) : (
							<Text tx={String(suffix)} inline />
						)}
					</div>
				)}
			</div>
		</div>
	),
);

export default Input;
